import { pagesText } from 'src/constants/pagesText';
import * as Yup from 'yup';
import { EMAIL_MAX_LENGTH } from 'src/validations/authValidation';

export const InviteUserSchema = Yup.object().shape({
  email: Yup.string()
    .trim()
    .email(pagesText.emailValidationErrorMessage)
    .max(EMAIL_MAX_LENGTH, `Email must be ${EMAIL_MAX_LENGTH} characters or fewer`)
    .required(pagesText.inviteUsers.validationMessages.email),
});
